var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{staticStyle:{"overflow":"auto"},attrs:{"height":_vm.height,"width":_vm.width,"series":[
        {
            name: this.seriesName,
            type: this.chartType,
            data: this.series1
        },
        {
            name: 'Reminders',
            type: 'bar',
            data: this.series2
        } ],"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }